const options = {
  apiKey: "AIzaSyDQMfjxhVnE3wGe54pDhOlAljNQqshloAU",
  authDomain: "minhamola-minhascompras.firebaseapp.com",
  projectId: "minhamola-minhascompras",
  storageBucket: "minhamola-minhascompras.appspot.com",
  messagingSenderId: "1031087603196",
  appId: "1:1031087603196:web:b20a44672acb81d19d4679",
  measurementId: "G-RFH4VMH60N"
};

export default options;